$(function() 
{
    $('.mxm_calculator_result_1 input').attr("readonly", "true");
    $('.mxm_calculator_result_2 input').attr("readonly", "true");

    $('.mxm_calculator_field').on('keyup', (e) => {
        var $target = $(e.target);
        var $targetId = $target.attr('id');

        var $targetGoal = $('#'+$targetId+'_target');
        var mul = $targetGoal.data('mul');
        $targetGoal.val(($target.val() * mul).toFixed(2));

        updateTotals();
    });
});

function updateTotals() 
{
    var $results = $('.mxm_calculator_result');
    var base = 320;
    var sum = 0;

     $results.each(function() {
         var val = parseFloat($(this).val());

        if (!isNaN(val)) {
            sum += parseFloat(val);
        }
    });
    var decimal = (sum - Math.floor(sum)) !== 0;

    if(decimal) {
        $('.mxm_calculator_result_1 input').val(sum.toFixed(2));
    } else {
        $('.mxm_calculator_result_1 input').val(sum);
    }
    
    var beschaeftigte = Math.round(sum);
    
    if (beschaeftigte > 40 ) {
        $('.mxm_calculator_result_2 input').val(base+
            (parseFloat(beschaeftigte)*15)+(20*45)+(20*15));
    } else {
        if (beschaeftigte > 20 ) {
            $('.mxm_calculator_result_2 input').val(base +
                (parseFloat(beschaeftigte)*30)+(20*30));
        } else { 
            if ($('#edit-submitted-beschaeftigte-js').val() < 1 && $('#edit-submitted-beschaeftigte-js').val() > 0) {
            beschaeftigte = 1;
            }
        $('.mxm_calculator_result_2 input').val(base+
            (parseFloat(beschaeftigte)*60));
        }
    }
}